import React, { useState, useEffect } from "react";
import CloseIcon from "@mui/icons-material/Close";
import { BasicTable } from "../scripts/Tables";
import Loader from "react-loader-spinner";
import NoteIcon from "@mui/icons-material/Note";
import { Box, Dialog, DialogContent, DialogTitle } from "@mui/material";
import Api_Call from "../../ApiCall";
import CustomModal from "../scripts/AuditModalBox";

const LetterPopUp = ({
  open,
  onClose,
  lettersData,
  isLoading,
  activeTaskId,
  setLettersOpen,
  setIsPdfVisible,
  setModalOpen,
  setLetterUrl,
  setIsCrossClickedOnLetterPopup,
}) => {
  const letterHandler = async (letterId, taskId) => {
    //   setLettersOpen(true);
    // setLoading(true);
    try {
      const api = new Api_Call();
      const data = await api.getData(
        `LETTERS/GENERATION?taskID=${taskId}&letter_id=${letterId}`
      );
      console.log(data.body);
      setLetterUrl(data.body.letter_url);
    } catch (error) {
      console.log("Error Occured");
    } finally {
      //   setLoading(false);
    }
  };

  const openModal = () => {
    setIsPdfVisible(true);
    setModalOpen(true);
  };

  var colums = [
    {
      width: "30%",
      textAlign: "center",
      Header: "Generated On",
      accessor: "Generated_On",
    },
    {
      width: "30%",
      textAlign: "center",
      Header: "Title",
      accessor: "Title",
    },
    {
      width: "30%",
      textAlign: "center",
      Header: "Description",
      accessor: "Description",
    },

    {
      width: "10%",
      textAlign: "center",
      Header: "View Letter",
      accessor: "",
      Cell: (props) => {
        return (
          <>
            <NoteIcon
              style={{ cursor: "pointer" }}
              onClick={() => {
                letterHandler(
                  props.row.original.Letter_Generated_ID,
                  activeTaskId
                );
                setLettersOpen(false);
                openModal();
                setIsCrossClickedOnLetterPopup(false);
              }}
            ></NoteIcon>
          </>
        );
      },
    },
  ];

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="lg"
      className="largeModalWrapper"
    >
      <DialogTitle variant="h6" onClose={onClose} className="dialog-title">
        Letter Details
        {onClose ? <CloseIcon onClick={onClose} /> : null}
      </DialogTitle>
      <DialogContent>
        <hr className="hr-style" />
        <Box className="tasklist-table audit-log-table">
          {isLoading ? (
            <Box className="loaderParent">
              <Loader type="Puff" color="#00BFFF" height={100} width={100} />
            </Box>
          ) : (
            <BasicTable
              columns={colums}
              tableData={lettersData}
              tableType="default"
            />
          )}
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default LetterPopUp;
